<template>
  <svg
    width="183"
    height="145"
    viewBox="0 0 183 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_12276_2987)">
      <rect
        x="12"
        y="3"
        width="159"
        height="110.327"
        rx="3"
        fill="#3E3F46"
      />
      <path
        d="M12 97.1021H171V110.327C171 111.983 169.657 113.327 168 113.327H15C13.3431 113.327 12 111.983 12 110.327V97.1021Z"
        fill="#EFF0F3"
      />
      <rect
        x="73.6536"
        y="113.326"
        width="37.3163"
        height="24.3367"
        fill="#EFF0F3"
      />
      <rect
        x="73.6528"
        y="136.041"
        width="37.3163"
        height="1.62245"
        fill="#D7D8DB"
      />
      <rect
        x="15.2449"
        y="6.24487"
        width="152.51"
        height="87.6122"
        fill="white"
      />
    </g>
    <rect
      x="55.25"
      y="11.25"
      width="73.5"
      height="78.5"
      fill="#FAFAFB"
      stroke="#D7D8DB"
      stroke-width="0.5"
    />
    <rect
      x="59.25"
      y="47.25"
      width="66.5"
      height="22.5"
      fill="white"
      stroke="#D7D8DB"
      stroke-width="0.5"
    />
    <path
      d="M75.9 17.734H79.08V17.794C79.08 18.002 79.074 18.214 79.062 18.43C79.05 18.642 79.008 18.886 78.936 19.162L79.416 19.216C79.492 18.94 79.536 18.688 79.548 18.46C79.56 18.232 79.566 18.01 79.566 17.794V17.338H75.9V17.734ZM80.172 19.972V19.57H77.808V18.538H77.316V19.57H75.33V19.972H80.172ZM77.73 20.464C77.442 20.464 77.182 20.486 76.95 20.53C76.722 20.574 76.526 20.64 76.362 20.728C76.202 20.812 76.078 20.916 75.99 21.04C75.902 21.16 75.858 21.298 75.858 21.454C75.858 21.606 75.902 21.744 75.99 21.868C76.078 21.988 76.202 22.09 76.362 22.174C76.526 22.258 76.722 22.322 76.95 22.366C77.182 22.414 77.442 22.438 77.73 22.438C78.018 22.438 78.276 22.414 78.504 22.366C78.736 22.322 78.934 22.258 79.098 22.174C79.262 22.09 79.388 21.988 79.476 21.868C79.564 21.744 79.608 21.606 79.608 21.454C79.608 21.298 79.564 21.16 79.476 21.04C79.388 20.916 79.262 20.812 79.098 20.728C78.934 20.64 78.736 20.574 78.504 20.53C78.276 20.486 78.018 20.464 77.73 20.464ZM77.73 22.054C77.31 22.054 76.974 22.002 76.722 21.898C76.474 21.79 76.35 21.642 76.35 21.454C76.35 21.262 76.474 21.112 76.722 21.004C76.974 20.896 77.31 20.842 77.73 20.842C78.154 20.842 78.49 20.896 78.738 21.004C78.99 21.112 79.116 21.262 79.116 21.454C79.116 21.646 78.99 21.794 78.738 21.898C78.49 22.002 78.154 22.054 77.73 22.054ZM85.5895 20.116V19.72H83.3995V19.096H85.0195V18.7H81.8215V17.704H84.9835V17.308H81.3295V19.096H82.9075V19.72H80.7175V20.116H85.5895ZM83.1535 20.5C82.5775 20.5 82.1255 20.584 81.7975 20.752C81.4695 20.92 81.3055 21.16 81.3055 21.472C81.3055 21.784 81.4695 22.024 81.7975 22.192C82.1255 22.36 82.5775 22.444 83.1535 22.444C83.4375 22.444 83.6935 22.422 83.9215 22.378C84.1495 22.338 84.3415 22.276 84.4975 22.192C84.6575 22.108 84.7795 22.006 84.8635 21.886C84.9475 21.766 84.9895 21.628 84.9895 21.472C84.9895 21.316 84.9475 21.178 84.8635 21.058C84.7795 20.938 84.6575 20.836 84.4975 20.752C84.3415 20.668 84.1495 20.606 83.9215 20.566C83.6935 20.522 83.4375 20.5 83.1535 20.5ZM83.1535 22.06C82.7175 22.06 82.3835 22.01 82.1515 21.91C81.9195 21.81 81.8035 21.664 81.8035 21.472C81.8035 21.28 81.9195 21.134 82.1515 21.034C82.3835 20.934 82.7175 20.884 83.1535 20.884C83.5775 20.884 83.9055 20.934 84.1375 21.034C84.3735 21.134 84.4915 21.28 84.4915 21.472C84.4915 21.664 84.3735 21.81 84.1375 21.91C83.9055 22.01 83.5775 22.06 83.1535 22.06ZM91.2629 20.998H91.7549V17.068H91.2629V20.998ZM90.2729 18.76C90.2729 18.568 90.2369 18.392 90.1649 18.232C90.0929 18.068 89.9929 17.928 89.8649 17.812C89.7409 17.692 89.5929 17.6 89.4209 17.536C89.2489 17.472 89.0629 17.44 88.8629 17.44C88.6629 17.44 88.4769 17.472 88.3049 17.536C88.1369 17.6 87.9889 17.692 87.8609 17.812C87.7369 17.928 87.6389 18.068 87.5669 18.232C87.4989 18.392 87.4649 18.568 87.4649 18.76C87.4649 18.956 87.4989 19.136 87.5669 19.3C87.6389 19.46 87.7369 19.6 87.8609 19.72C87.9889 19.836 88.1369 19.928 88.3049 19.996C88.4769 20.06 88.6629 20.092 88.8629 20.092C89.0629 20.092 89.2489 20.06 89.4209 19.996C89.5929 19.928 89.7409 19.836 89.8649 19.72C89.9929 19.6 90.0929 19.46 90.1649 19.3C90.2369 19.136 90.2729 18.956 90.2729 18.76ZM87.9449 18.76C87.9449 18.628 87.9669 18.508 88.0109 18.4C88.0589 18.292 88.1229 18.198 88.2029 18.118C88.2869 18.038 88.3849 17.976 88.4969 17.932C88.6089 17.888 88.7309 17.866 88.8629 17.866C88.9949 17.866 89.1169 17.888 89.2289 17.932C89.3449 17.976 89.4449 18.038 89.5289 18.118C89.6129 18.198 89.6769 18.292 89.7209 18.4C89.7689 18.508 89.7929 18.628 89.7929 18.76C89.7929 18.892 89.7689 19.014 89.7209 19.126C89.6769 19.238 89.6129 19.334 89.5289 19.414C89.4449 19.494 89.3449 19.556 89.2289 19.6C89.1169 19.644 88.9949 19.666 88.8629 19.666C88.7309 19.666 88.6089 19.644 88.4969 19.6C88.3849 19.556 88.2869 19.494 88.2029 19.414C88.1229 19.334 88.0589 19.238 88.0109 19.126C87.9669 19.014 87.9449 18.892 87.9449 18.76ZM91.9169 22.324V21.922H88.7849V20.596H88.2929V22.324H91.9169ZM93.0144 18.904L93.1884 19.294C93.4084 19.266 93.6204 19.222 93.8244 19.162C94.0324 19.098 94.2224 19.02 94.3944 18.928C94.5704 18.836 94.7244 18.73 94.8564 18.61C94.9924 18.49 95.0984 18.356 95.1744 18.208C95.2464 18.356 95.3484 18.492 95.4804 18.616C95.6164 18.736 95.7704 18.842 95.9424 18.934C96.1184 19.022 96.3104 19.098 96.5184 19.162C96.7264 19.222 96.9404 19.266 97.1604 19.294L97.3344 18.904C97.0984 18.88 96.8704 18.834 96.6504 18.766C96.4304 18.694 96.2344 18.608 96.0624 18.508C95.8944 18.404 95.7584 18.286 95.6544 18.154C95.5504 18.022 95.4964 17.882 95.4924 17.734H97.1664V17.338H93.1884V17.734H94.8564C94.8484 17.882 94.7924 18.022 94.6884 18.154C94.5884 18.286 94.4544 18.404 94.2864 18.508C94.1184 18.608 93.9244 18.694 93.7044 18.766C93.4844 18.834 93.2544 18.88 93.0144 18.904ZM97.6044 20.02V19.624H92.7384V20.02H97.6044ZM95.1684 20.488C94.5924 20.488 94.1404 20.572 93.8124 20.74C93.4884 20.908 93.3264 21.148 93.3264 21.46C93.3264 21.776 93.4884 22.018 93.8124 22.186C94.1404 22.354 94.5924 22.438 95.1684 22.438C95.4564 22.438 95.7124 22.416 95.9364 22.372C96.1644 22.332 96.3584 22.27 96.5184 22.186C96.6784 22.102 96.8004 22 96.8844 21.88C96.9684 21.756 97.0104 21.616 97.0104 21.46C97.0104 21.304 96.9684 21.166 96.8844 21.046C96.8004 20.926 96.6784 20.824 96.5184 20.74C96.3584 20.656 96.1644 20.594 95.9364 20.554C95.7124 20.51 95.4564 20.488 95.1684 20.488ZM95.1684 22.048C94.7444 22.048 94.4144 21.998 94.1784 21.898C93.9424 21.798 93.8244 21.652 93.8244 21.46C93.8244 21.268 93.9424 21.122 94.1784 21.022C94.4144 20.922 94.7444 20.872 95.1684 20.872C95.5924 20.872 95.9224 20.922 96.1584 21.022C96.3944 21.122 96.5124 21.268 96.5124 21.46C96.5124 21.652 96.3944 21.798 96.1584 21.898C95.9224 21.998 95.5924 22.048 95.1684 22.048ZM102.206 21.1H102.68V17.062H102.206V21.1ZM100.316 18.82H101.156V20.944H101.618V17.17H101.156V18.418H100.316V18.82ZM100.514 20.188L100.784 19.81C100.616 19.734 100.466 19.64 100.334 19.528C100.202 19.412 100.09 19.286 99.9979 19.15C99.9099 19.01 99.8419 18.862 99.7939 18.706C99.7499 18.55 99.7279 18.392 99.7279 18.232V17.44H99.2539V18.232C99.2539 18.388 99.2279 18.55 99.1759 18.718C99.1279 18.886 99.0559 19.048 98.9599 19.204C98.8679 19.356 98.7539 19.498 98.6179 19.63C98.4819 19.758 98.3259 19.864 98.1499 19.948L98.4259 20.326C98.6779 20.198 98.8939 20.024 99.0739 19.804C99.2579 19.584 99.3979 19.342 99.4939 19.078C99.5859 19.318 99.7179 19.534 99.8899 19.726C100.062 19.918 100.27 20.072 100.514 20.188ZM102.836 22.324V21.922H99.6619V20.608H99.1699V22.324H102.836ZM107.971 22.45V17.056H107.479V19.09H106.369V19.498H107.479V22.45H107.971ZM104.275 20.752V19.462H106.039V19.066H104.275V17.956H106.273V17.548H103.783V21.154H104.197C104.453 21.154 104.689 21.152 104.905 21.148C105.121 21.144 105.325 21.136 105.517 21.124C105.713 21.112 105.903 21.096 106.087 21.076C106.271 21.052 106.461 21.022 106.657 20.986L106.603 20.584C106.419 20.616 106.239 20.644 106.063 20.668C105.891 20.688 105.713 20.704 105.529 20.716C105.345 20.728 105.151 20.738 104.947 20.746C104.743 20.75 104.519 20.752 104.275 20.752Z"
      fill="#8E9098"
    />
    <rect
      x="59"
      y="28"
      width="16"
      height="16"
      fill="#E0E0E0"
    />
    <rect
      x="92"
      y="79"
      width="16"
      height="6"
      fill="#E0E0E0"
    />
    <rect
      x="110"
      y="79"
      width="16"
      height="6"
      fill="#E0E0E0"
    />
    <rect
      x="76"
      y="28"
      width="16"
      height="16"
      fill="#EDEDED"
    />
    <rect
      x="93"
      y="28"
      width="16"
      height="16"
      fill="#EDEDED"
    />
    <rect
      x="110"
      y="28"
      width="16"
      height="16"
      fill="#EDEDED"
    />
    <rect
      x="59"
      y="47"
      width="67"
      height="7"
      fill="#3F75E0"
    />
    <g filter="url(#filter1_d_12276_2987)">
      <path
        d="M12 97H171V110.224C171 111.881 169.657 113.224 168 113.224H15C13.3431 113.224 12 111.881 12 110.224V97Z"
        fill="#EFF0F3"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_12276_2987"
        x="7"
        y="0"
        width="169"
        height="144.663"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0 0.4875 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12276_2987"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12276_2987"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_12276_2987"
        x="0"
        y="90"
        width="183"
        height="40.2246"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0 0.486275 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12276_2987"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12276_2987"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
